module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00159.19999306.jpg";